import styles from './PurchaseDriversSection.module.scss';
import SkeletonText from '@/widgets/components/controls/Skeleton/SkeletonText.tsx';
import type { Product } from '@/domain/Product.ts';

export type PurchaseDriversSectionProps = {
  product: Product;
};

export default function PurchaseDriversSection({
  product
}: PurchaseDriversSectionProps) {
  if (!product.purchaseDrivers?.length) {
    return null;
  }

  return (
    <section class={styles.container}>
      <ul class={styles.list}>
        {product.purchaseDrivers?.map((driver) => (
          <li class={styles.item} key={driver}>
            <p class={styles.featureDescription}>{driver.description}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}

PurchaseDriversSection.Skeleton = function Skeleton() {
  return (
    <section>
      <SkeletonText />
    </section>
  );
};
